import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthBtns } from '../AuthBtns';
import { imgs as imgsData } from './data';
import * as Styled from './EditorialMedia.styles';

const EditorialMedia = () => {
  const { t } = useTranslation();

  const imgs = useMemo(
    () =>
      imgsData.map((img) => ({
        ...img,
        alt: t(`homeEditorialMedia.imgAlt.${img.key}`),
      })),
    [t],
  );

  return (
    <Styled.EditorialMedia id="editorial-media">
      <Styled.Title variant="h2">{t('homeEditorialMedia.title')}</Styled.Title>

      <Styled.Bottom>
        <Styled.Imgs>
          {imgs.map(({ key, src, alt }) => (
            <Styled.Img key={key} src={src} alt={alt} />
          ))}
        </Styled.Imgs>

        <AuthBtns />
      </Styled.Bottom>
    </Styled.EditorialMedia>
  );
};

export default EditorialMedia;
